import { useDrawingArea } from '@mui/x-charts/hooks'

interface Props {
  primary: string
  secondary: string | number
  secondaryColor?: string
}

const PieCenterLabel = ({ primary, secondary, secondaryColor = '#002C5F' }: Props) => {
  const { left, top, width, height } = useDrawingArea()
  const cx = left + width / 2
  const cy = top + height / 2

  return (
    <>
      <text x={cx} y={cy - 8} textAnchor='middle' dominantBaseline='middle' fontSize={11} fill='#8A94A6'>
        {primary.toUpperCase()}
      </text>
      <text x={cx} y={cy + 14} textAnchor='middle' dominantBaseline='middle' fontSize={20} fontWeight={700} fill={secondaryColor}>
        {secondary}
      </text>
    </>
  )
}

export default PieCenterLabel
